import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: function state() {
    return {
      pendingCount: null,
      signIn: null
    };
  },
  mutations: {
    /**
     * 记录待审核数量
     */
    setPendingCount: function setPendingCount(state, pendingCount) {
      state.pendingCount = pendingCount;
    },

    /**
     * 记录signIn
     */
    setSignIn: function setSignIn(state, signIn) {
      state.signIn = signIn;
    }
  },
  actions: {
    getPendingCount: function getPendingCount(_a, participationId) {
      var state = _a.state,
          commit = _a.commit;

      if (participationId === void 0) {
        participationId = null;
      }

      return __awaiter(this, void 0, void 0, function () {
        var params, response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              params = {};

              if (participationId) {
                params.participation_id = participationId;
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/check_sign_in_count', {
                params: params
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setPendingCount', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取审核内容
     */
    getSignIn: function getSignIn(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var participationId = _b.participationId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/check_sign_in', {
                params: {
                  participation_id: participationId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setSignIn', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 判决
     */
    judge: function judge(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var signInId = _b.signInId,
          action = _b.action,
          reason = _b.reason;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation/check_sign_in', {
                id: signInId,
                action: action,
                reason: reason
              })];

            case 1:
              response = _c.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    }
  }
};
export default m;